import React from 'react';
import { Helmet } from 'react-helmet-async';
import DynamicForm from '../DynamicForm';

export default function CheckoutPage() {
  return (
    <>
      <Helmet>
        <title>Decisive Sites - Checkout</title>
        <meta name="description" content="Complete your subscription purchase" />
      </Helmet>
      <DynamicForm />
    </>
  );
}
